<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="khyjl-search">
      <el-date-picker
        v-model="ktsj"
        type="date"
        placeholder="选择开通日期"
        style="width: 180px;margin-right: 10px;margin-bottom: 10px;">
      </el-date-picker>
      <el-input v-model="xueyuanMc" clearable placeholder="请输入学生姓名" style="width: 180px;margin-right: 10px;margin-bottom: 10px;"></el-input>
      <el-button @click="searchKhyjl" style="margin-right: 10px;margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
    </div>
    <div class="khyjl-table">
      <el-table	:data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号"></el-table-column>
        <el-table-column align="center" width="170" label="开通时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.ktsj),'yyyy-MM-dd hh:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="xueyuanBm" label="学生编号" width="130"></el-table-column>
        <el-table-column prop="xueyuanMc" label="学生姓名"></el-table-column>
        <el-table-column prop="lxdh" label="手机号" width="120"></el-table-column>
        <el-table-column prop="ktts" label="开通天数"></el-table-column>
        <el-table-column align="center" width="120" label="会员开始时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.hyksrq),'yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column align="center" width="120" label="会员结束时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.hyjsrq),'yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column prop="cjrmc" label="操作人"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="thyClick(scope.row)">退会员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="page-zj"
          v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
      </el-pagination>

    </div>
    <el-dialog
        title="退会员"
        :visible.sync="dialogVisible"
        width="500px"
        @close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="xueyuan" :rules="rules" ref="xueyuan" label-width="120px">
        <el-form-item label="剩余天数：">
          <span disabled style="width: 300px;">{{ syts }}</span>
        </el-form-item>
        <el-form-item label="积分：">
          <span disabled style="width: 300px;">{{ (syts * sxjf) }}</span>
        </el-form-item>
        <el-form-item label="退会员天数：" prop="thts">
          <el-input
              v-model="xueyuan.thts"
              clearable
              placeholder="请输入退会员天数"
              style="width: 300px;"
              min="1"
              step="1"
              @input="handleIntegerInput"></el-input>
        </el-form-item>
        <el-form-item label="退会员积分：">
          <span disabled style="width: 300px;">{{ (xueyuan.thts * sxjf) }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="thySave('xueyuan')">确定</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
	export default{
		name: "khyjl",
		data() {
		  return {
        jgglId: sessionStorage.getItem("jgglId"),
        loading: false,
        tableData: [],
        page: { page: 1, size: 10, total: 0 },
        ktsj: '',//开通时间
        xueyuanMc: '',//学员名称
        sxjf: '',//每日所需积分
        syts: '',//剩余天数
        dialogVisible: false,
        xueyuan: {
          xueyuanId: '',
          kthyId: '',
          thts: '',
          thjf: '',
        },
        rules: {
          thts: [
            { required: true, message: '请输入退会员天数', trigger: 'blur' },
            { validator: (rule, value, callback) => {
              if(value > this.syts){
                callback(new Error('退会员天数不能大于剩余天数'));
              }else{
                callback();
              }
            }, trigger: 'blur' }
          ]
        },

		  }
		},
		mounted() {
			this.findXueyuanKthyPage();
      this.findJgglView();
		},
		methods: {
      handleIntegerInput(value) {
        // 只保留正整数
        const intValue = value ? parseInt(value, 10) : '';
        if (!isNaN(intValue) && intValue > 0) {
          this.xueyuan.thts = intValue;
        } else{
          this.xueyuan.thts = '';
        }
      },
      thySave(formName){
        var _this = this;
        _this.$refs[formName].validate((valid) => {
          if(valid){
            _this.xueyuan.thjf = _this.xueyuan.thts * _this.sxjf;
            _this.$post('xueyuan/XueyuanController/xueyuanThy',this.xueyuan, 'json').then(res => {
              if(res.code == 1){
                _this.$message({
                  type: "success",
                  message: "退会员成功"
                });
                _this.dialogVisible = false;
                _this.findXueyuanKthyPage();
              }else{
                _this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        })
      },
      handleClose(){
        var _this = this;
        _this.$refs['xueyuan'].resetFields();
        _this.xueyuan = {
          xueyuanId: '',
          kthyId: '',
          thts: '',
          thjf: '',
        };
        _this.dialogVisible = false;
      },
      thyClick(row){
        var _this = this;
        _this.$post('xueyuan/XueyuanController/findHyrqList',{kthyId: row.id}).then(rep => {
          if(rep.code == 1){
            var list = rep.result.list;
            if(list.length > 0){
              // 计算剩余天数
              _this.syts = _this.calculateRemainingDays(list[0].hyksrq, list[0].hyjsrq);
              //_this.syts = list[0].hyts;
              _this.xueyuan.xueyuanId = row.xueyuanId;
              _this.xueyuan.kthyId = row.id;
              _this.dialogVisible = true;
            }else{
              _this.$message({
                type: "error",
                message: "会员已结束"
              });
            }
          }else{
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        });
      },
      //计算剩余天数
      calculateRemainingDays(hyksrq, hyjsrq) {
        const now = new Date(); // 当前时间
        const startDate = new Date(hyksrq); // 会员开始时间
        const endDate = new Date(hyjsrq);   // 会员结束时间

        // 将时间设置为当天的午夜（00:00:00）
        now.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        // 计算总天数
        const totalDays = Math.ceil((endDate - startDate + 1) / (1000 * 60 * 60 * 24));

        // 如果当前时间在会员时间段内
        if (now >= startDate && now <= endDate) {
          const daysPassed = Math.ceil((now - startDate) / (1000 * 60 * 60 * 24));
          return totalDays - daysPassed;
        } else if (now > endDate) {
          // 如果当前时间已经超过会员结束时间
          return 0; // 已过期
        } else {
          // 如果当前时间在会员开始时间之前
          return totalDays; // 还未开始
        }
      },
      findJglxView(jglxId){
        var _this = this;
        _this.$post('jggl/JgglController/jglxView',{id: jglxId}).then((rep) => {
          if (rep.code == 1) {
            var jglx = rep.result.jglx;
            _this.sxjf = jglx.sxjf;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      findJgglView(){
        var _this = this;
        _this.$post('jggl/JgglController/jgglView',{id: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            var jggl = rep.result.jggl;
            _this.sxjf = jggl.sxjf;
            //_this.findJglxView(jggl.jglxId);
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      searchKhyjl(){
        var _this = this;
        _this.page.page = 1;
        _this.findXueyuanKthyPage();
      },
      findXueyuanKthyPage(){
        var _this = this;
        var params = {
          jgglId: _this.jgglId,
          ktsj: _this.ktsj == null || _this.ktsj == '' ? '' :_this.formatDate(_this.ktsj, 'yyyy-MM-dd'),
          xueyuanMc: _this.xueyuanMc,
          page: _this.page.page - 1,
          size: _this.page.size
        }
        _this.loading = true;
        _this.$post('xueyuan/XueyuanController/xueyuanKthyPage',params).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.tableData = rep.result.page.content;
            _this.page.total = rep.result.page.totalElements;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
			},
      // 每页条数
      handleSizeChange(val) {
        this.page.size = val;
        this.findXueyuanKthyPage();
      },
      // 当前页
      handleCurrentChange(val) {
        this.page.page = val;
        this.findXueyuanKthyPage();
      },
		}
	}
</script>

<style lang="less" scoped>
  .khyjl-search{
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
	.khyjl-table{
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
	}
</style>